export default {
  label: {
    security: 'Security Template',
  },
  buttonType: {
    WL: 'Web Link',
    AL: 'App Link',
    AC: 'Add Channel',
    DS: 'Delivery inquiry',
  },
  comment: {
    security: '※ This message can only be viewed on the main device mobile.',
  },
  placeholder: {
    content: 'When you import the template, the content is entered.',
    customerSetting: '※ You can change the variables that are registered in the template.',
  },
  preview: {
    head: 'AlimTalk Received',
  },
};
